







import { defineComponent, ref, onMounted } from '@vue/composition-api';
import 'iframe-resizer/js/iframeResizer';
declare const iFrameResize: any;

export default defineComponent({
	props: {
		liveUrl: {
			type: String,
			required: true,
		},
		errorText: {
			type: String,
			default: 'Bitte geben Sie die URL einer ECON-Strecke an.'
		},
	},
	setup() {
		const econFrame = ref<HTMLIFrameElement | null>();

		onMounted(() => {
			if (econFrame.value) {
				iFrameResize({}, econFrame.value)
			}
			
		});
		return { econFrame };
	},
});
